import { createAction, props } from '@ngrx/store';
import { CustomerCard } from '../models/customer-card';

export const fetchCustomerCards = createAction('[Cards]: Fetch customer cards');
export const fetchCustomerCardsSuccess = createAction(
    '[Cards]: Fetch customer cards succeeded',
    props<{ customerCards: CustomerCard[] }>()
);
export const fetchCustomerCardsFailed = createAction('[Cards]: Fetch customer cards failed');
export const blockCard = createAction('[Cards]: Block card', props<{ card: CustomerCard }>());
export const blockCardFailed = createAction('[Cards]: Block card failed');
export const unblockCard = createAction('[Cards]: Unblock card', props<{ card: CustomerCard }>());
export const unblockCardFailed = createAction('[Cards]: Unblock card failed');
export const deleteRelatedCard = createAction('[Cards]: Delete related card', props<{ card: CustomerCard }>());
export const deleteRelatedCardFailed = createAction('[Cards]: Delete related card failed');
